import React, { useState, useRef } from "react";
import { Grid, Button } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";


// styles
import useStyles from "./styles";

// components
import Widget from "../../Components/Widget";
import PageTitle from "../../Components/PageTitle";
import { Typography } from "../../Components/Wrappers";
import Miscellaneous from "../../Components/Miscellaneous/miscellaneous";
import TextMerger from "../../Components/TextMerger/TextMerger";
import UrlDecoder from "../../Components/UrlDecoder/UrlDecoder";
import Base64Decoder from "../../Components/Base64Decoder/Base64Decoder";
import JsonExporter from "../../Components/JsonExporter/JsonExporter";
import PunycodeDecoder from "../../Components/PunycodeDecoder/PunycodeDecoder";

import ParameterReporter from "../../Components/ParameterReporter/ParameterReporter";
import CriteoBlocklistExport from "../../Components/CriteoBlocklistExport/CriteoBlocklistExport";

import DomainBlockingToolConverter from "../../Components/DomainBlockingToolConverter/DomainBlockingToolConverter";
import BidRequestAnalyser from "../../Components/BidRequestAnalyser/BidRequestAnalyser";
const mainChartData = getMainChartData();
const PieChartData = [
  { name: "Group A", value: 400, color: "primary" },
  { name: "Group B", value: 300, color: "secondary" },
  { name: "Group C", value: 300, color: "warning" },
  { name: "Group D", value: 200, color: "success" },
];

export default function Dashboard(props) {
  var classes = useStyles();
  var theme = useTheme();
  const urlopener = useRef(null);
  const textmerger = useRef();
  const urldecoder = useRef();
  const base64decoder = useRef();
  const jsonexporter = useRef();
  const punycodetourl = useRef();
  const parameterreporter = useRef();
  const criteoblocklist = useRef();
  const domainblockingtoolconverter = useRef();

  const executeScroll = () => urlopener.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  const executeScroll2 = () => textmerger.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  const executeScroll3 = () => urldecoder.current.scrollIntoView({ behavior: 'smooth', block: 'start' })  
  const executeScroll4 = () => base64decoder.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  const executeScroll5 = () => jsonexporter.current.scrollIntoView({ behavior: 'smooth', block: 'start' }) 
  const executeScroll6 = () => punycodetourl.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  const executeScroll7 = () => parameterreporter.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  const executeScroll8 = () => criteoblocklist.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  const executeScroll9 = () => domainblockingtoolconverter.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
  // local
  var [mainChartState, setMainChartState] = useState("monthly");

  return (
    <>
    
      <PageTitle title="Miscellaneous tools" />
      <Button variant="contained" color="primary" onClick={executeScroll}>Url opener</Button>  &nbsp;
      <Button variant="contained" color="primary" onClick={executeScroll2}>Text merger</Button>  &nbsp;
      <Button variant="contained" color="primary" onClick={executeScroll9}>Domain blocking tool converter</Button> &nbsp;
      <Button variant="contained" color="primary" onClick={executeScroll3}>Url decoder</Button>  &nbsp;
      <Button variant="contained" color="primary" onClick={executeScroll4}>Base64 Decoder</Button>  &nbsp;
      <Button variant="contained" color="primary" onClick={executeScroll5}>Sellers.json exporter</Button>  &nbsp;
      <Button variant="contained" color="primary" onClick={executeScroll6}>Punycode to URL converter</Button>  <br></br><br></br>
      <Button variant="contained" color="primary" onClick={executeScroll7}>Parameter reporter</Button> &nbsp;
      <Button variant="contained" color="primary" onClick={executeScroll8}>Criteo Blocklist Export</Button>  &nbsp;

      <br></br><br></br><br></br>
      <div ref={urlopener}></div>
      <Grid container spacing={4}>
        <Grid item xs={12}>
        
          <Widget
            title="aa"
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
            
          >
            
           <Typography>Url Opener</Typography>
            <Miscellaneous></Miscellaneous>
          </Widget>
          
        </Grid>
        
        
        
       
      </Grid>
      <Grid container spacing={4}>
      <div ref={textmerger}></div>
        <Grid item xs={12}>
          
          <Widget
            title="aa"
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
            
          >
           <Typography>Text Merger</Typography>
            <TextMerger></TextMerger>
          </Widget>
          
        </Grid>
        
        
        
       
      </Grid>


      <Grid container spacing={4}>
      <div ref={domainblockingtoolconverter}></div>
        <Grid item xs={12}>
          
          <Widget
            title="aa"
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
            
          >
           <Typography>Domain blocking tool converter</Typography>
            <DomainBlockingToolConverter></DomainBlockingToolConverter>
          </Widget>
          
        </Grid>
        
        
        
       
      </Grid>

      <Grid container spacing={4}>
      <div ref={urldecoder}></div>
        <Grid item xs={12}>
          
          <Widget
            title="aa"
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
            
          >
           <Typography>Url Decoder</Typography>
            <UrlDecoder></UrlDecoder>
          </Widget>
          
        </Grid>
        
        
        
       
      </Grid>
      <Grid container spacing={4}>
      <div ref={base64decoder}></div>
        <Grid item xs={12}>
          
          <Widget
            title="aa"
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
            
          >
           <Typography>Base64 Decoder</Typography>
            <Base64Decoder></Base64Decoder>
          </Widget>
          
        </Grid>
        
        
        
       
      </Grid>
      <Grid container spacing={4}>
      <div ref={jsonexporter}></div>
        <Grid item xs={12}>
        
          <Widget
            title="aa"
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
            
          >
           
           
           <Typography>JSON Exporter</Typography>
           <JsonExporter></JsonExporter>
          </Widget>
          
        </Grid>
        
        
        
       
      </Grid>
      <Grid container spacing={4}>
      <div ref={punycodetourl}></div>
        <Grid item xs={12}>
        
          <Widget
            title="aa"
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
            
          >
           
           
           <Typography>Punycode to URL</Typography>
           <PunycodeDecoder></PunycodeDecoder>
          </Widget>
          
        </Grid>
        
        <Grid container spacing={4}>
        <div ref={parameterreporter}></div>
        <Grid item xs={12}>
        
          <Widget
            title="aa"
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}>
           <Typography>Parameter Reporter</Typography>
           <ParameterReporter></ParameterReporter>
          </Widget>
          
        </Grid>
        </Grid>
        <Grid container spacing={4}>
        <div ref={criteoblocklist}></div>
        <Grid item xs={12}>
        
          <Widget
            title="aa"
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}>
           <Typography>Criteo Blocklist Export</Typography>
           <CriteoBlocklistExport></CriteoBlocklistExport>
          </Widget>
          
        </Grid>
        </Grid>
    
        <Grid container spacing={4}>
  
        <Grid item xs={12}>
          
          <Widget
            title="aa"
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
            
          >
           <Typography>Bid Requests Analyser</Typography>
            <BidRequestAnalyser></BidRequestAnalyser>
          </Widget>
          
        </Grid>
        
        
        
       
      </Grid>
      </Grid>
    </>
  );
}

// #######################################################################
function getRandomData(length, min, max, multiplier = 10, maxDiff = 10) {
  var array = new Array(length).fill();
  let lastValue;

  return array.map((item, index) => {
    let randomValue = Math.floor(Math.random() * multiplier + 1);

    while (
      randomValue <= min ||
      randomValue >= max ||
      (lastValue && randomValue - lastValue > maxDiff)
    ) {
      randomValue = Math.floor(Math.random() * multiplier + 1);
    }

    lastValue = randomValue;

    return { value: randomValue };
  });
}

function getMainChartData() {
  var resultArray = [];
  var tablet = getRandomData(31, 3500, 6500, 7500, 1000);
  var desktop = getRandomData(31, 1500, 7500, 7500, 1500);
  var mobile = getRandomData(31, 1500, 7500, 7500, 1500);

  for (let i = 0; i < tablet.length; i++) {
    resultArray.push({
      tablet: tablet[i].value,
      desktop: desktop[i].value,
      mobile: mobile[i].value,
    });
  }

  return resultArray;
}
